import { Link } from "react-router-dom";
import { Clock, ArrowUpRight, Play } from "lucide-react";
import { resolveUrl } from "@/lib/api";

export default function JourneyCard({ journey, testId }) {
    return (
        <Link
            to={`/jornada/${journey.slug}`}
            data-testid={testId || `journey-card-${journey.slug}`}
            className="journey-card group"
        >
            <div className="relative">
                <img src={resolveUrl(journey.cover)} alt={journey.title} className="cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/0 to-transparent" />

                {/* Centered play badge — visible always, lifts on hover */}
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="w-16 h-16 rounded-full bg-white/25 backdrop-blur-md border border-white/40 flex items-center justify-center shadow-2xl transition-all duration-300 opacity-80 group-hover:opacity-100 group-hover:scale-110">
                        <Play className="w-6 h-6 text-white fill-white ml-1" />
                    </div>
                </div>

                {journey.is_free && (
                    <span className="absolute top-3 left-3 bg-white/90 backdrop-blur text-[#1A1A1A] text-[10px] tracking-[0.18em] uppercase font-display px-2.5 py-1 rounded-full">
                        Grátis
                    </span>
                )}
                <span className="absolute top-3 right-3 bg-black/55 backdrop-blur text-white text-xs font-display px-2.5 py-1 rounded-full flex items-center gap-1">
                    <Clock className="w-3 h-3" /> {Math.round(journey.total_minutes / 60 * 10) / 10}h
                </span>
            </div>
            <div className="p-5">
                <div className="overline text-[#5C5C5C]">{journey.category?.name || "Jornada"}</div>
                <h3 className="font-display text-lg mt-1.5 leading-snug line-clamp-2">{journey.title}</h3>
                <p className="font-body text-sm text-[#5C5C5C] mt-2 line-clamp-2">{journey.subtitle}</p>
                <div className="flex items-center justify-between mt-4">
                    <div className="flex items-center gap-2.5">
                        {journey.mentor && (
                            <img src={resolveUrl(journey.mentor.photo)} alt={journey.mentor.name}
                                 className="w-7 h-7 rounded-full object-cover" />
                        )}
                        <span className="font-body text-xs text-[#5C5C5C]">{journey.mentor?.name}</span>
                    </div>
                    <ArrowUpRight className="w-4 h-4 text-[#1A1A1A] opacity-50 group-hover:opacity-100 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                </div>
            </div>
        </Link>
    );
}
